import React, { useMemo, useState } from 'react';
import s from './Slot.module.css';
import ImageFilter from 'react-image-filters-tool';
import { ImageAttributes } from '../../../../shared/types/imagesType';

import UploadImage from '../upload-image/UploadImage';
import { useTransformedImage } from '../../../../shared/hooks/useTransformedImage';
import Loader from '../../../../shared/ui/loader/Loader';

type SlotProps = {
    img?: ImageAttributes | null;
    saveImage: (file: File) => void;
};

const areEqual = (prevProps: SlotProps, nextProps: SlotProps) => {
    return prevProps.img === nextProps.img;
};

const Slot: React.FC<SlotProps> = React.memo(({ img, saveImage }) => {
    const originalUrl = img?.original_url ?? '';
    const transformedUrl = useTransformedImage(originalUrl, img?.transformation, {
        format: 'webp',
        quality: 0.92,
        crossOrigin: 'anonymous',
    });

    const handleContextMenu = (e: React.MouseEvent) => {
        e.preventDefault();
    };

    if (!img) {
        return (
            <div className={`${s.slot} ${s.empty}`}>
                <UploadImage saveImage={saveImage} />
            </div>
        );
    }

    if (!transformedUrl) {
        return (
            <div className={`${s.slot} ${s.empty}`}>
                <Loader text="Loading your image..." blur={true} />
            </div>
        );
    }

    return (
        <div className={`${s.slot}`} onContextMenu={handleContextMenu}>
            <ImageFilter
                imageUrl={transformedUrl}
                filter={img?.visual_effects.name ?? undefined}
                brightness={img?.visual_settings.brightness}
                contrast={img?.visual_settings.contrast}
                saturation={img?.visual_settings.saturation}
                hueRotate={img?.visual_settings.hue}
                redChannel={img?.visual_settings.red}
                greenChannel={img?.visual_settings.green}
                blueChannel={img?.visual_settings.blue}
                grain={img?.visual_settings.grain}
                vignette={img?.visual_settings.vignette}
                shadows={img?.visual_settings.shadows}
                highlights={img?.visual_settings.highlights}
                saveImage={saveImage}
                filterIntensity={img?.visual_effects.intensity}
            />
        </div>
    );
}, areEqual);

export default Slot;
